import { computed, ref } from "#imports";
export default function(storage) {
  const showDebug = storage.use("showDebug", false);
  const visible = storage.use("visibleDebugOverlays", []);
  const registeredOverlays = ref([]);
  const isEnabled = computed(() => showDebug.value);
  function toggle() {
    showDebug.value = !showDebug.value;
  }
  function log(...v) {
    if (!showDebug.value) {
      return;
    }
    console.log(v);
  }
  function createLogger(name) {
    return {
      log(...v) {
        if (!showDebug.value) {
          return;
        }
        console.log(`[${name}]: `, ...v);
      },
      error(...v) {
        if (!showDebug.value) {
          return;
        }
        console.error(`[${name}]: `, ...v);
      }
    };
  }
  function registerOverlay(id, label) {
    registeredOverlays.value.push({ id, label });
  }
  function unregisterOverlay(id) {
    registeredOverlays.value = registeredOverlays.value.filter(
      (v) => v.id !== id
    );
  }
  const overlays = computed(() => {
    return registeredOverlays.value.map((v) => {
      return {
        ...v,
        active: visible.value.includes(v.id)
      };
    });
  });
  function toggleOverlay(id) {
    if (visible.value.includes(id)) {
      visible.value = visible.value.filter((v) => v !== id);
    } else {
      visible.value = [...visible.value, id];
    }
  }
  return {
    isEnabled,
    toggle,
    log,
    createLogger,
    registerOverlay,
    unregisterOverlay,
    overlays,
    toggleOverlay
  };
}
